export const useDefaultData = ({Helpers}) => {
    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idstampslogs: '',
        idstamp: '',
        date_transaction: getCurrentDate(),
        type_transaction: '',
        quantity: '',
        observations: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}